// Static asset URLs (external CDN, no bundling)
export const LOGOS = {
  // Client company logo (Express Trans) - used in Header only
  clientBrand:
    "https://customer-assets.emergentagent.com/job_visa-danomjer/artifacts/ozxm7k03_1.webp",
  clientBrandName: "Express Trans",
  // Developer company logo (OffGround) - white wordmark, used on Login + Footer
  developer:
    "https://customer-assets.emergentagent.com/job_visa-danomjer/artifacts/fgekvs4f_1.Logo_white-Offground.webp",
  developerName: "OffGround",
  developerUrl: "https://offground.solutions",
};
